export default class ResizableTableClass  {

  constructor(table, isFixed, fixedColumnLength = 0, onResize) {
    this.table = table
    this.isFixed = isFixed
    this.fixedColumnLength = fixedColumnLength
    this.header = null
    this.headerColumns = null
    this.headerColumnsMinWidths = []
    this.tableBodyRows = null
    this.tableBodyCurColRows = null
    this.pageX = null
    this.curCol = null
    this.curColIndex = null
    this.curColWidth = null
    this.curColumnPadding = 0
    this.curColumnRowCells = null
    this.curColumnRowCellsContents = null
    this.nxtCol = null
    this.nxtColWidth = null
    this.resizing = false,
    this.onResize = onResize;
    this.selectingToDrag = false;
    this.selectDragColumnElement = null;

    this.mouseOverListener = (e) => {
      e.target.style.borderRight = '2px solid #9b9b9b'
    }

    this.mouseOutListener = (e) => {
      e.target.style.borderRight = ''
    }

    this.mouseUpDivListener = (e) => {
      if (this.selectingToDrag) {
        this.onResize(this.selectDragColumnElement);
        this.selectingToDrag = false;
      }
    }

    this.mouseMoveListener = (e) => {
      if(!this.resizing) return
      if (this.curCol) {
        var diffX = e.pageX - this.pageX;

        if(this.headerColumnsMinWidths[this.curColIndex] >= (this.curColWidth + (diffX))) return

        this.curCol.style.width = this.curColWidth + (diffX)+'px';
        this.curCol.style.minWidth = this.curColWidth + (diffX)+'px';
        this.curCol.style.maxWidth = this.curColWidth + (diffX)+'px';
        this.setColumnRowWidth(this.curColWidth + diffX)
      }
    }

    this.mouseDownListener =(e) => {
      this.selectingToDrag = true;
      this.selectDragColumnElement = e;
      this.resizing = true
      this.setCols(e)
      this.setCurColumnRowCells()
      this.pageX = e.pageX;

      var padding = this.paddingDiff(this.curCol);
      this.curColWidth = this.curCol.offsetWidth - padding;
      if (this.nxtCol) this.nxtColWidth = this.nxtCol.offsetWidth - padding;
    }

    this.mouseUpListener = () => {
      this.mouseUpDivListener();
      this.resizing = false
      this.curCol = undefined;
      this.curColIndex = undefined;
      this.nxtCol = undefined;
      this.pageX = undefined;
      this.nxtColWidth = undefined;
      this.curColWidth = undefined
      this.curColumnRowCells = null
      this.curColumnRowCellsContents = null
      this.curColumnPadding = null
    }
  }

  mount() {
    // if(!this.isFixed) this.table.classList.add('table-wrapper--overflow')
    // if(!this.fixedColumnLength) this.table.style.overflow = 'hidden';
    this.header = this.table && this.table.getElementsByTagName('tr')[0]
    this.headerColumns = this.header ? this.header.children : undefined
    this.parseMinimumHeaderWidths()
    this.getTableBodyRows()
    this.setColsRelative()
    this.createWrappers()
    this.setCellColumnPadding()
    this.setGlobalListeners()
  }

  unmount() {
    this.removeResizers()
    document.removeEventListener('mousemove', this.mouseMoveListener, true)
  }

  setCellColumnPadding() {
    const tbody = this.table && this.table.getElementsByTagName('tbody')[0]
    if(!tbody) return
    const cells = tbody.getElementsByClassName('cell-content')
    if(!cells) return
    const paddingLeft = parseInt(this.getStyleVal(cells[0], "padding-left"))
    const paddingRight = parseInt(this.getStyleVal(cells[0], "padding-right"))
    this.curColumnPadding = paddingLeft + paddingRight
  }

  updateTableHeight() {
    this.headerColumns && Array.from(this.headerColumns).forEach((column) => {
      let resizers = column.getElementsByClassName('resizer')
      if(resizers) {
        Array.from(resizers).forEach((resizer) => this.setHeight(resizer))
      }
    })
  }

  getTableBodyRows() {
    this.tableBodyRows =  this.table && this.table.querySelectorAll('tbody tr')
  }

  createWrappers() {
    this.headerColumns && Array.from(this.headerColumns).forEach((column, index) => {
      if(index >= this.fixedColumnLength) {
        column.appendChild(this.createWrapper());
      }
    })
  }

  createWrapper () {
    var div = document.createElement('div');
    div.setAttribute("class", "resizer");
    div.style.top = 0;
    div.style.right = 0;
    div.style.width = '5px';
    div.style.position = 'absolute';
    div.style.cursor = 'col-resize';
    div.style.userSelect = 'none';
    this.setHeight(div)
    this.setResizerListeners(div);
    return div;
  }

  setResizerListeners(div){
    div.addEventListener('mouseup', this.mouseUpDivListener)
    div.addEventListener('mousedown', this.mouseDownListener.bind(this));
    div.addEventListener('mouseover', this.mouseOverListener.bind(this))
    div.addEventListener('mouseout', this.mouseOutListener)
  }

  setGlobalListeners() {
    document.addEventListener('mousemove', this.mouseMoveListener.bind(this));
    document.addEventListener('mouseup', this.mouseUpListener.bind(this));
  }

  parseMinimumHeaderWidths() {
    if (this.headerColumns) Array.from(this.headerColumns).forEach((column, index) => {
      const children = column.getElementsByClassName('cell-content')

      Array.from(children).forEach(child => {
        let minWidth = 36;
        Array.from(child.children).forEach(grandChild => {
          minWidth += grandChild.clientWidth
        })
        this.headerColumnsMinWidths[index] = minWidth
      })
    })
  }

  setCols(e) {
    this.curCol = e.target.parentElement;
    this.nxtCol = this.curCol.nextElementSibling;

    this.setCurColIndex(this.curCol.dataset.column)
  }

  setCurColIndex(attr) {
    this.curColIndex = Array.from(this.headerColumns).findIndex(column => column.dataset.column === attr)
  }

  setCurColumnRowCells() {
    this.curColumnRowCells = Array.from(this.tableBodyRows).map(row => row.getElementsByTagName('td')[this.curColIndex])
    this.curColumnRowCellsContents = this.curColumnRowCells.map(td => {
      return td.getElementsByClassName('cell-content')[0]
    })
  }

  setColumnRowWidth(width) {
    this.curColumnRowCellsContents.forEach(item => {
      item.style.width = width - this.curColumnPadding + 'px'
      item.style.minWidth = width - this.curColumnPadding + 'px'
      item.style.maxWidth = width - this.curColumnPadding + 'px'
    })
  }

  paddingDiff(col){

    if (this.getStyleVal(col,'box-sizing') == 'border-box'){
      return 0;
    }

    var padLeft = this.getStyleVal(col,'padding-left');
    var padRight = this.getStyleVal(col,'padding-right');
    return (parseInt(padLeft) + parseInt(padRight));

  }

  getStyleVal(elm,css){
    return (window.getComputedStyle(elm, null).getPropertyValue(css))
  }

  setColsRelative() {
    this.headerColumns && Array.from(this.headerColumns).forEach((col, i) => {
      if (this.fixedColumnLength <= i && !col.classList.contains('toggle-columns-wrapper')) col.style.position = 'relative'
    })
  }

  setHeight(el) {
    el.style.height = this.table.offsetHeight + 'px'
  }

  removeResizers() {
    let resizers = this.table.getElementsByClassName('resizer')
    Array.from(resizers).forEach(resizer =>  resizer.remove())
  }
}